import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiAccessibilityModule } from "../accessibility/accessibility.module";
import { UiButtonModule } from "../button/button.module";
import { UiIconModule } from "../icon/icon.module";
import { UiToastContainerComponent } from "./components/toast-container/toast-container.component";
import { UiToastService } from "./services/toast.service";
import { UiToastComponent } from "./toast.component";

@NgModule({
  imports: [CommonModule, NzOutletModule, OverlayModule, LocalizationModule, UiIconModule, UiButtonModule, UiAccessibilityModule],
  declarations: [UiToastContainerComponent, UiToastComponent],
  exports: [UiToastContainerComponent, UiToastComponent],
  providers: [UiToastService],
})
export class UiToastModule {}
